import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import withAuth from '../../hocs/withAuth';

import LoadingCard from '../../cards/LoadingCard';

import { fetchUpgradePopup } from '../../../actions/upgrade-to-power-actions';
import ListItem from '../UpgradeCheckList/ListItem';
import UpgradeCheckList from '../UpgradeCheckList';
import TrackedClick from '../../Analytics/TrackedClick';

import styles from './upgradeToPerformanceHs.scss';
import { getClickAttrs } from '../../Analytics/gtag';

const UpgradeToPerformanceHsContent = props => {
    const {
        handleUpgradeClick,
        clubOptionsToUpgrade,
        upgradePopup,

        fetchUpgradePopupContent,
    } = props;

    const [clubToUpgrade, setClubToUpgrade] = useState(null);

    useEffect(() => {
        fetchUpgradePopupContent('performancehsclub');

        let newClubToUpgrade = null;

        if (clubOptionsToUpgrade && clubOptionsToUpgrade.length === 1) {
            newClubToUpgrade = {
                id: clubOptionsToUpgrade[0].value,
                name: clubOptionsToUpgrade[0].label,
                tierTypeName: 'high school',
            };
        }

        setClubToUpgrade(newClubToUpgrade);
    }, []);

    const handleClubUpgradeChange = (e) => {
        const { selectedIndex } = e.nativeEvent.target;

        if (selectedIndex > 0) {
            setClubToUpgrade({
                id: parseInt(e.target.value),
                name: e.nativeEvent.target[selectedIndex].text,
                tierTypeName: 'high school',
            });
        } else {
            setClubToUpgrade(null);
        }
    };

    const { data } = upgradePopup;
    const yearlyButtonText = data.yearlybuttontext ? data.yearlybuttontext : 'Upgrade to Performance High School';

    if (upgradePopup.isLoading) {
        return (
            <LoadingCard />
        );
    }

    return (
        <>
            <UpgradeCheckList
                title={data.title}
                intro={data.subtitle}
            >
                {data.bulletpoints && data.bulletpoints.map((bulletpoint, i) => (
                    <ListItem key={`upgrade-bullet-${i}`}>{bulletpoint}</ListItem>
                ))}
                {(clubOptionsToUpgrade && clubOptionsToUpgrade.length > 1) && (
                    <div className={`d-flex flex-row ${styles.listItem}`}>
                        <select
                            className="form-control"
                            onChange={(e) => handleClubUpgradeChange(e)}
                        >
                            <option value="">Select a school to upgrade to Performance High School</option>
                            {clubOptionsToUpgrade.map((option) => {
                                return (
                                    <option value={option.value} key={option.value}>{option.label}</option>
                                );
                            })}
                        </select>
                    </div>
                )}
            </UpgradeCheckList>
            <div>
                <div className={`d-flex flex-row ${styles.buttonArea}`}>
                    <div className="w-100">
                        <TrackedClick
                            eventName="Upgrade to Performance High School Click"
                            label={yearlyButtonText}
                            traits={
                                {
                                    pageLocation: 'upgrade to Performance High School Popup',
                                    uxType: 'button',
                                    content: yearlyButtonText,
                                    subscriptionType: 'Performance High School',
                                }
}
                        >
                            <button
                                type="button"
                                className={`w-100 btn btn-primary btn-block btn-xl text-uppercase font-weight-normal`}
                                onClick={() => {
                                    handleUpgradeClick(clubToUpgrade);
                                }}
                                disabled={!clubToUpgrade}
                                {...getClickAttrs({
                                    category: 'Upgrade to Performance High School',
                                    context: `Upgrade to Performance High School`,
                                    location: 'upgrade to Performance High School Popup',
                                })}
                            >
                                {yearlyButtonText}
                            </button>
                        </TrackedClick>
                    </div>
                </div>
            </div>
        </>
    );
};

const mapStateToProps = ({ auth, upgradePopup }) => {
    return { auth, upgradePopup };
};

const mapDispatchToProps = dispatch => {
    return {
        fetchUpgradePopupContent: (prismicUid) => dispatch(fetchUpgradePopup(prismicUid)),
    };
};

export default withAuth(connect(mapStateToProps, mapDispatchToProps)(UpgradeToPerformanceHsContent));
